<template>
  <div class="page-payment-methods" v-loading="loadingData">

    <div v-if="!isResellerAccount && partnerType === 'WHITELABEL'">
      <h2 class="mb-0 mt-0">
        No available billing data
      </h2>
      <p>
        The selected account is under a white label umbrella.
      </p>
    </div>

    <div v-else>

      <h2 class="form-section-header">
        Payment Methods
      </h2>

      <div class="flex align-center mb-10">
        <el-button @click="openCreateModal('bank')">
          Add new bank account
        </el-button>
      </div>

      <el-row v-if="bankAccounts.length > 0" class="mt-0" :gutter="30">
        <el-col class="davi-card" :xs="20" :sm="20" :md="8" :lg="8" :xl="8" v-for="account in bankAccounts" v-bind:key="account.index">
          <div class="card-base card-shadow--medium mt-10 mb-20 widget small-widget">
            <div class="widget-header ph-10 pt-10">
              <div class="flex">
                <div class="widget-info box grow text-truncate p-10">
                  <div class="widget-title text-truncate flex">
                    <p v-if="account.default">
                      Primary
                    </p>
                    <el-button
                      class="del-btn voxo-red"
                      :id="delete-account.index"
                      type="text"
                      @click="deleteOperation(account.id, 'bank')"
                    >
                      Remove
                    </el-button>
                  </div>
                  <div class="black-text pt-5"><strong>{{ account.name }}</strong></div>
                  <div class="black-text">{{ account.bankName }}</div>
                  <div class="black-text">{{ account.accountNumber }}</div>
                  <div class="black-text">{{ account.routingNumber }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row v-else>
        <p class="mt-10">No bank accounts payment methods found</p>
      </el-row>

      <div class="flex align-center mb-10 mt-10">
        <el-button @click="openCreateModal('card')">
          Add new credit card
        </el-button>
      </div>

      <el-row v-if="cardPayments.length > 0" class="mt-0 mb-20" :gutter="30">
        <el-col class="davi-card" :xs="20" :sm="20" :md="8" :lg="8" :xl="8" v-for="card in cardPayments" v-bind:key="card.index">
          <div class="card-base card-shadow--medium mt-10 widget small-widget">
            <div class="widget-header ph-10 pt-10">
              <div class="flex">
                <div class="widget-info box grow text-truncate p-10">
                  <div class="widget-title text-truncate flex">
                    <p v-if="card.default">
                      Primary
                    </p>
                    <el-button
                      class="del-btn voxo-red"
                      type="text"
                      :id="delete-card.index"
                      @click="deleteOperation(card.id, 'card')"
                    >
                      Remove
                    </el-button>
                  </div>
                  <div class="flex">
                    <h3 class="black-text">{{ card.name }}</h3>
                    <h3 class="black-text card-name">{{ card.cardType }}</h3>
                  </div>
                  <div class="black-text">{{ card.number }}</div>
                  <div class="black-text">{{ card.status }}</div>
                  <div class="black-text">EXP {{ card.expMonth }}/{{ card.expYear }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row v-else class="mb-20">
        <p class="mt-10">No credit card payment methods found</p>
      </el-row>

      <div v-loading="autoPayChanging">
        <h2 class="form-section-header mt-20 mb-0">
          Automatic Payments
        </h2>

        <div v-if="isAutoPay" class="flex align-center">
          <div>
            <p class="mb-0">Automatic payments are enabled</p>
            <p style="font-size: 13px; font-style: italic;" class="mt-0">
              {{ autoPayInfo.name }}
              {{ autoPayInfo.number || autoPayInfo.accountNumber }}
            </p>
          </div>
          <div class="ml-20">
            <el-button @click="disableAutoPay">Disable</el-button>
          </div>
          <div class="ml-5" v-if="canChangeAuto">
            <el-button @click="autoPaySelectVisible = true">Change</el-button>
          </div>
        </div>

        <div v-else class="flex align-center">
          <div>
            <p class="mb-0">
              Automatic payments are disabled for your account
            </p>
            <p v-if="!canEnableAuto" style="font-size: 13px; font-style: italic;" class="mt-0">
              No primary payment methods available
            </p>
          </div>
          <div class="ml-20" v-if="canEnableAuto">
            <el-button @click="autoPaySelectVisible = true">Enable</el-button>
          </div>
        </div>
      </div>

      <auto-pay-form
        :banks="bankAccounts"
        :cards="cardPayments"
        :visible="autoPaySelectVisible"
        @closed="autoPaySelectVisible = false"
        @optionSelected="handleAutoPaySelect"
      />

      <create-bank-form
        :createBankVisible="createBankVisible"
        :createBankProcessing="createBankProcessing"
        :clearFormFields="clearFormFields"
        :typeOptions="typeOptions"
        @createBankOperation="createBankOperation"
        @cancelOperation="cancelOperation"
      />

      <create-card-form
        :createCardVisible="createCardVisible"
        :createCardProcessing="createCardProcessing"
        :clearFormFields="clearFormFields"
        @createCardOperation="createCardOperation"
        @cancelOperation="cancelOperation"
      />
    </div>


  </div>
</template>

<script>

  import feathersClient from '../../../feathers/feathers-client';
  import CreateBankForm from "./components/createBankForm.vue";
  import CreateCardForm from "./components/createCardForm.vue";
  import AutoPayForm from "./components/autoPayConfirm.vue";

  export default {
    name: 'Payment-Methods',
    components: { CreateCardForm, CreateBankForm, AutoPayForm },
    data() {
      return {
        cardPayments: [],
        bankAccounts: [],
        qbAccount: {},
        autoPayInfo: {},
        autoPaySelectVisible: false,
        paymentMethod: "1",
        autoPayChanging: false,
        canChangeAuto: false,
        canEnableAuto: false,
        createBankVisible: false,
        createCardVisible: false,
        createBankProcessing: false,
        createCardProcessing: false,
        deleteProcessing: false,
        clearFormFields: false,
        loadingData: false,
        isAutoPay: false,
        typeOptions: [
        {
          label: "Personal Checking",
          value: "PERSONAL_CHECKING"
        },
        {
          label: "Personal Savings",
          value: "PERSONAL_SAVINGS"
        },
        {
          label: "Business Checking",
          value: "BUSINESS_CHECKING"
        },
        {
          label: "Business Savings",
          value: "BUSINESS_SAVINGS"
        },
      ],
      }
    },
    computed: {
      user() {
        return this.$store.state.auth.user;
      },
      selectedTenant() {
        return this.$store.state.selectedTenant;
      },
      isResellerAccount() {
        return this.selectedTenant
          ? this.selectedTenant.isResellerAccount
          : false;
      },
      partnerType() {
        return this.selectedTenant ? this.selectedTenant.resellerType : false;
      }
    },
    watch: {
      user() {
        if(this.user){
          this.findPaymentMethods();
        }
      },
      selectedTenant(){
        this.findPaymentMethods();
      }
    },
    methods: {
      findPaymentMethods() {

        if(!this.isResellerAccount && this.partnerType === 'WHITELABEL') return;

        this.paymentMethods = [];
        this.loadingData = true;
        this.cards = [];
        this.bankAccounts = [];
        this.qbAccount = {};
        feathersClient
        .service("billing")
        .find({
          query: {
            context: 'paymentMethods',
            tenantId: this.selectedTenant.id,
            $sort: {
              date: -1
            }
          },
        })
        .then((res) => {

          this.bankAccounts = [...res.bankAccounts.sort(item => item.default ? -1 : 1)];
          this.cardPayments = [...res.cards.sort(item => item.default ? -1 : 1)];
          this.qbAccount = {...res.qbAccount};

          //figure out auto payment info
          const customer = this.qbAccount.Customer;
          if(customer){
            const custPaymentMethod = customer.PaymentMethodRef;
            if(custPaymentMethod){
              this.paymentMethod = custPaymentMethod.value;
              this.isAutoPay = +this.paymentMethod === 2 || +this.paymentMethod === 3
            }

            this.getAutoPayInfo();
          }

          this.loadingData = false;
        })
        .catch(e => {
          this.loadingData = false;
        });
      },
      openCreateModal(type) {
        //console.log('type is: ', type);
        if (type === "card")
          {
            this.createCardVisible = true;
            this.createBankVisible = false;
          } else {
            this.createBankVisible = true;
            this.createCardVisible = false;
          }

        this.clearFormFields = false;
      },
      createBankOperation(params) {
        const createBody = { ...params };

        this.$confirm("Process bank account create?", "Warning", {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning"
        })
          .then(() => {
            this.createBankProcessing = true;
            feathersClient.service('billing').create(createBody, {
              query: {
                tenantId: this.selectedTenant.id
              }
            })
              .then((res) => {
                this.$notify({
                  title: "Success",
                  message: "Created successfully!",
                  type: "success"
                });
                this.createBankProcessing = false;
                this.clearFormFields = true;

                const accounts = [...this.bankAccounts];
                if(res.default){
                  for(let i = 0; i < accounts.length; i++){
                    accounts[i].default = false;
                  }
                }
                accounts.push({...res});
                this.bankAccounts = accounts.sort(item => item.default ? -1 : 1);
                this.getAutoPayInfo();
                this.cancelOperation("create");
              })
              .catch(error => {
                this.clearFormFields = false;

                if (error.hasOwnProperty("errors")) {
                  this.$notify({
                    title: "Invalid data",
                    message: error.message,
                    type: "error"
                  });
                } else {
                  this.$notify({
                    title: "Invalid data",
                    message: error.message,
                    type: "error"
                  });
                }

                this.createBankProcessing = false;
              });
          })
          .catch(() => true);
      },
      createCardOperation(params) {
        const createBody = { ...params };

        this.$confirm("Process card create?", "Warning", {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning"
        })
          .then(() => {
            this.createCardProcessing = true;
            feathersClient.service('billing').create(createBody, {
              query: {
                tenantId: this.selectedTenant.id
              }
            })
              .then((res) => {
                this.$notify({
                  title: "Success",
                  message: "Created successfully!",
                  type: "success"
                });
                this.createCardProcessing = false;
                this.clearFormFields = true;

                const cards = [...this.cardPayments];
                if(res.default){
                  for(let i = 0; i < cards.length; i++){
                    cards[i].default = false;
                  }
                }

                cards.push({...res});
                this.cardPayments = cards.sort(item => item.default ? -1 : 1);

                this.getAutoPayInfo();
                this.cancelOperation("create");
              })
              .catch(error => {
                this.clearFormFields = false;

                if (error.hasOwnProperty("errors")) {
                  this.$notify({
                    title: "Invalid data",
                    message: error.message,
                    type: "error"
                  });
                } else {
                  this.$notify({
                    title: "Invalid data",
                    message: error.message,
                    type: "error"
                  });
                }

                this.createCardProcessing = false;
              });
          })
          .catch(() => true);
      },
      cancelOperation(type) {
        this[`${type}BankVisible`] = false;
        this[`${type}CardVisible`] = false;
        this.clearFormFields = true;
      },
      deleteOperation(accountId, type) {

        this.$confirm(`Remove ${type} account?`, "Warning", {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning"
        })
          .then(() => {
            this.loadingData = true;

            const isAutoPayAccount = accountId === this.autoPayInfo.id;
            feathersClient.service('billing').remove(accountId, {
              query: {
                paymentType: type,
                tenantId: this.selectedTenant.id,
              }
            })
              .then(() => {
                this.loadingData = false;
                this.bankAccounts = this.bankAccounts.filter(item => item.id !== accountId);
                this.cardPayments = this.cardPayments.filter(item => item.id !== accountId);
                this.$notify({
                  title: "Success",
                  message: `Deleted ${type} account successfully!`,
                  type: "success"
                });

                if(isAutoPayAccount){
                  this.disableAutoPay();
                }

                this.getAutoPayInfo();
              })
              .catch(error => {
                if (error.hasOwnProperty("errors")) {
                  this.$notify({
                    title: error.message,
                    message: error.errors[Object.keys(error.errors)[0]],
                    type: "error"
                  });
                } else {
                  this.$notify({
                    title: error.name,
                    message: error.message,
                    type: "error"
                  });
                }
                this.loadingData = false;
              });
          })
          .catch(() => true);
      },

      handleAutoPaySelect(value){
        this.autoPaySelectVisible = false;
        const isBank = this.bankAccounts.some(item => item.id === value);
        const isCard = this.cardPayments.some(item => item.id === value);
        if(isBank) this.paymentMethod = '2';
        if(isCard) this.paymentMethod = '3';
        this.enableAutoPay();
      },

      enableAutoPay() {
         this.autoPayChanging = true;
         feathersClient.service("billing").patch(null, {
           paymentMethod: this.paymentMethod,
           billingCode: this.selectedTenant.billingCode,
         }).then((res) => {
          this.isAutoPay = true;
          this.getAutoPayInfo();
          this.autoPayChanging = false;
         }).catch((e) => {
          console.log("could not enable auto pay", e);
          this.autoPayChanging = false;
       });
      },

      disableAutoPay(){
        this.autoPayChanging = true;
        feathersClient.service("billing").patch(null, {
          paymentMethod: "1",
          billingCode: this.selectedTenant.billingCode,
        }).then((res) => {
          this.autoPayInfo = {};
          this.isAutoPay = false;
          this.paymentMethod = "1";
          this.autoPayChanging = false;
        }).catch(e => {
          console.log("payment method not disabled", e)
          this.autoPayChanging = false;
        });
      },

      getAutoPayInfo(){
        if(this.isAutoPay){
          this.autoPayInfo = +this.paymentMethod === 2
            ? {...this.bankAccounts.find(item => item.default)}
            : {...this.cardPayments.find(item => item.default)}
        }

        //check if autopay is available or can be modified
        this.canChangeAuto = this.bankAccounts.some(item => item.default) && this.cardPayments.some(item => item.default);
        this.canEnableAuto = [...this.bankAccounts, ...this.cardPayments].some(item => item.default);
      }
    },
    mounted() {
      if(this.user){
        this.findPaymentMethods();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/variables';

  .page-payment-methods {
    overflow: auto;

    .card-base {
      max-height: 200px;

      h2 {
        svg {
          width: 25px;
          height: 25px;
          padding-right: 6px;
        }
      }
    }
    .widget-title {
        font-weight: 700;
        border-bottom: 1px solid $border-color-light;
        margin-bottom: 5px;

        .el-button--text:hover {
          color: $voxo-red;
        }

        .del-btn {
          margin-left: auto;
          margin-bottom: 14px;
          padding: 2px;
          margin-top: 0px;
          text-transform: uppercase;
        }
      }
  }

  .widget-info {
    text-transform: uppercase;
    h1, h4 {
      margin: 0;
    }

    h3 {
      margin-bottom: 5px;
      margin-top: 5px;
    }

    .card-name {
      margin-left: auto;
    }

    p {
      font-size: 14px;
      // uppercase
      text-transform: uppercase;
      margin-top: 0;
      padding-bottom: 0;
      margin-bottom: 14px;
    }

  }

  .dashboard-button-group {
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      padding-left: 10px;
    }
  }

  .dashboard-button {
    text-align: center;
    padding: 18px;
  }
</style>
